/*
 * https://www.drupal.org/docs/8/api/javascript-api/javascript-api-overview
 */

(function ($, Drupal) {
  'use strict';

  // Namespace definition.
  Drupal.res = Drupal.res || {};

  // Defining date picker package.
  Drupal.res.datePicker = Drupal.res.datePicker || {
    format: 'dd/MM/yyyy',
    calendars: {},
    getDate: function ($calendar) {
      return $calendar
        .parent('.form-group')
        .find('input.it-date-datepicker')
        .val()
    }
  };

  /**
   * Component Library Initialization.
   *
   * @type {{attach: Drupal.behaviors.componentLibraryInitialization.attach}}
   */
  Drupal.behaviors.componentLibraryInitialization = {
    attach: function (context, settings) {
      const $context = $(context);

      // Initialize tooltip
      $context.find('[data-toggle="tooltip"]').tooltip();
      // Initialize date picker.
      $context.find('.it-date-datepicker').datepicker({
        inputFormat: [Drupal.res.datePicker.format],
        outputFormat: Drupal.res.datePicker.format,
      });

      // Register initial and final values in order to avoid resubmitting forms
      // even when dates didn't change at all.
      $context.find('.datepicker-calendar')
        .on('ab.datepicker.opening', function (e) {
          const $calendar = $(e.currentTarget);
          Drupal.res.datePicker.calendars[$calendar.attr('id')] = Drupal.res.datePicker.getDate($calendar);
        })
        .on('ab.datepicker.closed', function (e) {
          const $calendar = $(e.currentTarget);
          if (Drupal.res.datePicker.calendars[$calendar.attr('id')] !== Drupal.res.datePicker.getDate($calendar)) {
            $(this).parents('form').find('[data-bef-auto-submit-click]').click()
          }
        });
      
      
      var $owl = $(".path-frontpage #it-block-inprimopiano .owl-carousel");
      if ($owl) {
        $owl.owlCarousel({
          nav: true,
          loop: false,
          margin: 24,
          items: 1,
          navText: ['<svg class="icon"><use xlink:href="/themes/custom/res/assets/icons/sprite.svg#it-chevron-left"></use></svg>', '<svg class="icon"><use xlink:href="/themes/custom/res/assets/icons/sprite.svg#it-chevron-right"></use></svg>'],
          navSpeed: 300,
          smartSpeed: 500,
          dotsSpeed: 200,
          navElement: 'button',
          dotElement: 'button',
          controlsAriaHidden: true,
          mouseDrag: true,
          touchDrag: true,
          dots: false,
          slideBy: 'page',
          stagePadding: 0,
          responsive: {
            0: {
              nav: false,
              dots: true,
              items: 1,
              stagePadding: 0,
              margin: 24,
            },
            768: {
              nav: true,
              dots: true,
              stagePadding: 0,
              items: 1,
              margin: 24,
            },
            992: {
              nav: true,
              dots: true,
              items: 1,
              stagePadding: 0,
              margin: 0,
            },
            1200: {
              nav: true,
              dots: true,
              stagePadding: 0,
              items: 1,
              margin: 0,
            },
          },
          onInitialized: function(event) {
            $(event.target)
              .find('.owl-dot')
              .each(function(index) {
                $(this).attr('aria-labelledby', 'owl-dot-' + index)
              })
          },
        });  
        
        
      }


      
    }
  };


  $('.layout-header-subheader-gallery .second-column div div div a').html('<svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="1.53906" y="1.625" width="12.5" height="13.75" rx="0.75" stroke="#0048ad" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.5391 4.125V17.25C16.5391 17.5952 16.2592 17.875 15.9141 17.875H4.03906" stroke="#0048ad" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.0391 6.625V19.75C19.0391 20.0952 18.7592 20.375 18.4141 20.375H6.53906" stroke="#0048ad" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.0391 11.625H1.53906" stroke="#0048ad" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.28906 11.6248L8.7499 6.68144C8.97012 6.36694 9.32266 6.1711 9.70603 6.15028C10.0894 6.12946 10.4611 6.28598 10.7141 6.57477L14.0391 10.3748" stroke="#0048ad" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.66406 4.4375C4.83665 4.4375 4.97656 4.57741 4.97656 4.75C4.97656 4.92259 4.83665 5.0625 4.66406 5.0625C4.49147 5.0625 4.35156 4.92259 4.35156 4.75C4.35156 4.57741 4.49147 4.4375 4.66406 4.4375" stroke="#0048ad" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>Scarica la Gallery');

  var icon_card = '<svg class="icon icon-sm"><use href="/themes/custom/res/assets/icons/sprite.svg#it-arrow-right" class=" it-arrow-right"></use></svg>';
  $('.card-infografica .read-more .text').append(icon_card);
  $('.card-video .read-more .text').append(icon_card);

  var icon_poll = '<svg class="icon icon-md icon-primary"><use href="/themes/custom/res/assets/icons/sprite.svg#it-arrow-right" class=" it-arrow-right"></use></svg>';
  $('.link-polls a').append(icon_poll);

  
  // Workaround for map carousels
  $(function () {
    if (
      $('.owl-loaded') &&
      $(['data-block-plugin-id="field_block:node:generic_page:field_p_body"'])
        .length
    ) {

      window.dispatchEvent(new Event('resize'));
    }
  });

})(jQuery, Drupal);


